import * as Styled from "./DocumentFiltersForm.styled"

export function DocumentFiltersFormSkeleton() {

    return <Styled.Skeleton />
}